var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4444 10.5984V7.33177C16.4444 6.81844 16.0444 6.39844 15.5556 6.39844H4.88889C4.4 6.39844 4 6.81844 4 7.33177V16.6651C4 17.1784 4.4 17.5984 4.88889 17.5984H15.5556C16.0444 17.5984 16.4444 17.1784 16.4444 16.6651V13.3984L20 17.1318V6.8651L16.4444 10.5984Z",
    fill: "#2B43DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIconSelected);
export default __webpack_public_path__ + "static/media/videoIconSelected.fa9b2d16d96db0ca640f99e7dcf61a6f.svg";
export { ForwardRef as ReactComponent };